<div class="d-flex align-items-center">
<ul ngbNav #nav="ngbNav" class="nav-tabs">
	<li ngbNavItem>
		<a ngbNavLink>{{name}}</a>
		<ng-template ngbNavContent>
            <form [class.scroll-x]="scrollX">
                <ng-content></ng-content>
            </form>
		</ng-template>
	</li>
</ul>
<!-- Kontrolleur-Toolbar (fest in Header-Zeile) -->
@if (ps.amI('kontrolleur') && bp) {
	<div class="control-toolbar-inline">
		<!-- Modus-Toggle: Eintragen / Kommentieren -->
		<div class="btn-group btn-group-sm" role="group">
			<button type="button" class="btn"
				[class.btn-success]="!aus.commenting"
				[class.btn-outline-secondary]="aus.commenting"
				(click)="aus.commenting = false"
				title="Eintragen-Modus">
				<i class="bi bi-pencil-square"></i>
			</button>
			<button type="button" class="btn"
				[class.btn-primary]="aus.commenting"
				[class.btn-outline-secondary]="!aus.commenting"
				(click)="aus.commenting = true"
				title="Kommentieren-Modus">
				<i class="bi bi-chat-dots"></i>
			</button>
		</div>
		<!-- Kommentar-Werkzeuge (nur im Kommentieren-Modus) -->
		@if (aus.commenting) {
			<div class="toolbar-divider"></div>
			<button type="button" class="btn btn-sm"
				[class.btn-danger]="aus.pen === 'danger'"
				[class.btn-outline-danger]="aus.pen !== 'danger'"
				(click)="aus.pen = 'danger'" title="Fehler markieren">
				<i class="bi bi-pen"></i>
			</button>
			<button type="button" class="btn btn-sm"
				[class.btn-warning]="aus.pen === 'warning'"
				[class.btn-outline-warning]="aus.pen !== 'warning'"
				(click)="aus.pen = 'warning'" title="Warnung markieren">
				<i class="bi bi-pen"></i>
			</button>
			<button type="button" class="btn btn-sm"
				[class.btn-secondary]="aus.pen === 'message'"
				[class.btn-outline-secondary]="aus.pen !== 'message'"
				(click)="aus.pen = 'message'" title="Neutraler Kommentar">
				<i class="bi bi-pen"></i>
			</button>
			<button type="button" class="btn btn-sm"
				[class.btn-dark]="aus.pen === 'rubber'"
				[class.btn-outline-dark]="aus.pen !== 'rubber'"
				(click)="aus.pen = 'rubber'" title="Kommentar löschen">
				<i class="bi bi-eraser"></i>
			</button>
		}
	</div>
}
<!-- Protokoll-Info -->
<span class="protocol-info ms-auto me-3" *ngIf="bp">
	<img [src]="'assets/img/points/' + bp.type + '.svg'" alt="" class="protocol-type-icon">
	<span class="protocol-nummer">{{ bp.header?.nummer || '–' }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ bp.header?.aufnahme?.kartierer || '–' }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ dateString(bp.header?.aufnahme?.datum) || '–' }}</span>
</span>
</div>
<div [ngbNavOutlet]="nav"></div>
